export default {
  'layouts.userLayout.title': 'DocFluxa - エンタープライズAIインテリジェントドキュメント管理システム',

  // ログインページ
  'login.accountLogin.tab': 'アカウントログイン',
  'login.failure': 'ログインに失敗しました。もう一度お試しください！',
  'login.success': 'ログイン成功！',
  'login.password.expired': 'パスワードの有効期限が切れました。パスワードをリセットしてください！',
  'login.password.update.success': 'パスワードの更新に成功しました！',
  'login.password.update.fail': 'パスワードの更新に失敗しました',
  'login.request.fail': 'リクエストに失敗しました。後でもう一度お試しください',
  'login.password.security': 'パスワードは8文字以上で、英字・数字・記号をすべて含む必要があります！',
  'login.contactAdmin': 'パスワードをお忘れですか？管理者に連絡してください！',
  'login.alterPassword': 'パスワードの変更',
  'login.password.strength.strong': '強度：強',
  'login.password.strength.medium': '強度：中',
  'login.password.strength.short': '強度：短すぎる',
  'login.password.twice.match': '入力された2つのパスワードが一致しません！',
  'login.password.length': 'パスワードは8文字以上である必要があります！',
  'login.password.case': 'パスワードは英字・数字・記号をすべて含む必要があります！',
  'login.password.diff': '新しいパスワードは現在のパスワードと同じにすることはできません！',
  'login.password.tips': '8文字以上入力し、英字・数字・記号をすべて含めてください。',
  'login.currentPassword.required': '現在のパスワードを入力してください！',
  'login.currentPassword.placeholder': '現在のパスワード',
  'login.newPassword.placeholder': '8文字以上で、英字・数字・記号を含むパスワード',
  'login.confirmPassword.required': 'パスワードを確認してください！',
  'login.confirmPassword.placeholder': 'パスワードの確認',
  'login.backToLogin': '既存のアカウントでログイン',
  'login.updatePassword': 'パスワードを更新',
  'login.username.placeholder': 'ユーザー名',
  'login.username.required': 'ユーザー名を入力してください！',
  'login.password.placeholder': 'パスワード',
  'login.password.required': 'パスワードを入力してください！',
  'login.forgotPassword': 'パスワードをお忘れですか？',
  'login.forgotPassword.modal.title': 'パスワードのリセット',
  'login.forgotPassword.modal.content': 'アカウント【{account}】に紐付けられたメールアドレスにパスワードリセットメールを送信します。メールボックスにログインしてリセット操作を完了してください。',
  'login.forgotPassword.modal.confirm': '送信する',
  'login.forgotPassword.modal.cancel': 'キャンセル',
  'login.forgotPassword.success': 'パスワードリセットメールを送信しました。ご確認ください！',
  'login.forgotPassword.fail': '送信に失敗しました。後でもう一度お試しください。',

  // ログインページ レイアウト
  'login.submit': 'ログイン',
  'login.formSubTitle': 'アカウントとパスワードを入力して続行してください',
  'login.leftTitle': 'エンタープライズインテリジェントドキュメント管理プラットフォーム',
  'login.leftSubTitle': '知識を効率的に流通させ、チームのスマートな協力を支援します',
  'login.feature.docParsing': 'インテリジェントドキュメント解析・管理',
  'login.feature.ragKnowledge': 'RAGナレッジベース構築・検索',
  'login.feature.aiQA': 'AI駆動のコンテンツQ&A',
  'login.feature.permissionMgmt': 'エンタープライズ権限管理',
  'login.feature.multiAppIntegration': 'マルチアプリ統合サポート',

  // パスワード変更ページ
  'login.alertPwd.subTitle': '現在のパスワードと新しいパスワードを入力してください',

  // パスワードリセットページ
  'resetPassword.title': 'パスワードのリセット',
  'resetPassword.subTitle': '新しいログインパスワードを設定してください',
  'resetPassword.leftTitle': 'パスワードをリセット',
  'resetPassword.leftSubTitle': '8文字以上で、英字・数字・記号を含む安全な新しいパスワードを設定してください。',
  'resetPassword.account': 'アカウント',
  'resetPassword.submit': 'パスワードをリセット',
  'resetPassword.success': 'パスワードのリセットが完了しました。新しいパスワードでログインしてください！',
  'resetPassword.fail': 'リセットに失敗しました。もう一度お試しください。',
  'resetPassword.invalidLink': 'リンクが無効または期限切れです。パスワードリセットを再申請してください。',
  'resetPassword.fetchError': 'アカウント情報の取得に失敗しました。もう一度お試しください。',
};
